import api from './index'

export function getMarketPrices(params = {}) {
  return api.get('/api/v1/market-prices', { params })
}

export function getMarketPriceLongHistory(params = {}) {
  return api.get('/api/v1/market-prices/long-history', { params })
}
